import React from 'react';
import { Redirect, Route, RouteComponentProps } from 'react-router';
import { SubRouterProps } from 'modules/shared/types';

// Point d'entrée du module redirection catalogue
const RedirectionCatalogue: React.FC<SubRouterProps> = ({ navigationTree }: SubRouterProps) => {
    return (
        <Route
            path={navigationTree.path}
            render={(subProps: RouteComponentProps) => {
                return <Redirect to={subProps.location.pathname.replace(/\/listes/gi, '')} />;
            }}
        />
    );
};

export default RedirectionCatalogue;
